import React, { useState, useEffect, useRef, useContext } from 'react';
import HeaderDetails from "../../components/header/header_details";
import DataDetails from "../home/data-details/data-details";
import axios from 'axios';
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MenuContext } from "../../views/dashboard/admin/admin"; 

function VuelosFacturados() {
    const handleMenuClick = useContext(MenuContext);
    const [collapsed, setCollapsed] = useState(true);
    const [collapsed2, setCollapsed2] = useState(true);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totales, setTotales] = useState([]);
    const [year, setYear] = useState(0);
    const [week, setWeek] = useState(0);
    
    // Estados para la tabla lateral
    const [Estaciones, setEstaciones] = useState(0);
    const [MexDom, setMexDom] = useState(0);
    const [MexExpo, setMexExpo] = useState(0);
    const [Impo, setImpo] = useState(0);
    const [VuelosFacturadosVar, setVuelosFacturados] = useState(0);

    // ESTADOS PARA PAGINACIÓN
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const containerRef = useRef(null);

    // 1. LÓGICA DE SCROLL (Igual a Facturados)
    const handleScroll = () => {
        if (containerRef.current) {
            const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 20 && hasMore && !loading) {
                setPage((prevPage) => prevPage + 1);
            }
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return () => container.removeEventListener('scroll', handleScroll);
        }
    }, [hasMore, loading]);

    // 2. FUNCIÓN DE PETICIÓN (Corregida: No limpia el array dentro de la función)
    const getDashboard = async (isNewSearch = false) => {
        try {
            setLoading(true);
            const searchParams = new URLSearchParams(window.location.search);
            const weekParam = searchParams.get('week');
            const yearParam = searchParams.get('year');

            if (weekParam && yearParam) {
                setYear(yearParam);
                setWeek(weekParam);

                const res = await axios.post(`${process.env.REACT_APP_URL_BACKEND}/dashboard/detail_operated`, {
                    params: {
                        'week': weekParam,
                        'year': yearParam,
                        "page": isNewSearch ? 1 : page,
                        "limit": 500
                    },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });

                if (res.data.code === 1) {
                    const newResults = res.data.results || [];
                    
                    // Si es nueva búsqueda, reemplaza. Si es scroll, concatena.
                    setData((prevData) => isNewSearch ? newResults : [...prevData, ...newResults]);
                    setTotales(res.data.totales_semanas || []);
                    
                    // Si el backend manda menos de 500, ya no hay más
                    if (newResults.length < 500) {
                        setHasMore(false);
                    }
                } else {
                    setHasMore(false);
                }
            }
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    // 3. EFECTOS DE CONTROL
    // Cuando cambia la URL (nueva búsqueda)
    useEffect(() => {
        setPage(1);
        setHasMore(true);
        setData([]); // Limpieza controlada aquí, no dentro de getDashboard
        getDashboard(true);
    }, [window.location.search]);

    // Cuando cambia la página (scroll)
    useEffect(() => {
        if (page > 1) {
            getDashboard(false);
        }
    }, [page]);

    // 4. LÓGICA DE RENDERIZADO AL DOM (Idéntica a la que te funcionó en Facturados)
    useEffect(() => {
        const tbody = document.getElementById('main-data');
        if (!tbody) return;

        // LIMPIEZA VISUAL: Borramos el tbody antes de redibujar para evitar duplicados físicos
        tbody.innerHTML = '';

        if (data.length > 0) {
            let pedro = 1;
            data.forEach((row) => {
                const tr = document.createElement('tr');

                const values = [
                    pedro,
                    row.folio_fiscal || '',
                    row.folio_fiscal || '',
                    row.clave || '',
                    row.anio || '',
                    row.semana || '',
                    row.tiempo_demora || '',
                    'AMC',
                    row.origen || '',
                    row.destino || '',
                    row.guias || '',
                    row.importe_mx || 0,
                    row.kgsFact || 0,
                    '-'
                ];

                values.forEach(val => {
                    const td = document.createElement('td');
                    td.textContent = val;
                    tr.appendChild(td);
                });

                tbody.appendChild(tr);
                pedro++;
            });

            if (totales && totales.length > 0) {
                setEstaciones(totales[0].sem_actual_estaciones_este_vuelo || 0);
                setMexDom(totales[0].sem_actual_mex_dom_esta_semana || 0);
                setMexExpo(totales[0].sem_actual_mex_expo_esta_semana || 0);
                setImpo(totales[0].sem_actual_impo_esta_semana || 0);
                setVuelosFacturados(totales[0].vuelos_sem_actual_facturados_esta_semana || 0);
            }
        }
    }, [data, totales]);

    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();
        const wsMain = XLSX.utils.table_to_sheet(document.getElementById('main-table'));
        const wsSecondary = XLSX.utils.table_to_sheet(document.getElementById('secondary-table'));
        XLSX.utils.book_append_sheet(wb, wsMain, 'Vuelos Operados');
        XLSX.utils.book_append_sheet(wb, wsSecondary, 'Totales');
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        const buffer = new ArrayBuffer(wbout.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xff;
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'vuelos_operados.xlsx');
    };

    const toggleCollapse = () => setCollapsed(!collapsed);
    const toggleCollapse2 = () => setCollapsed2(!collapsed2);

    return (
        <div className="main-section">
            <div className="row mt-4 px-4">
                <div className="col-12 d-flex align-items-end justify-content-center mt-2">
                    <p className=""><b>Vuelos Operados</b></p>
                </div>
                <div className="col-12 d-flex align-items-end justify-content-end mb-3">
                    <span className="blue-pill c-pointer" onClick={exportToExcel}>
                        <p className="fs-11 mt-2 mb-2 me-3 ms-3">Exportar</p>
                    </span>
                </div>
                
                <div className={`col-md-2 fs-10 ${collapsed ? '' : 'd-none'}`}>
                    <table className="table table-hover" id="secondary-table">
                        <thead>
                            <tr className="bg-color-gray text-white">
                                <th>Semana</th><th>Concepto</th><th>Total</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            <tr className="bg-color-gray">
                                <td rowSpan="5">{ year%10 }{ week }</td>
                                <td>Estaciones</td><td>{ Estaciones }</td>
                            </tr>
                            <tr className="bg-color-gray"><td>Mex Dom</td><td>{ MexDom }</td></tr>
                            <tr className="bg-color-gray"><td>Mex Expo</td><td>{ MexExpo }</td></tr>
                            <tr className="bg-color-gray"><td>Impo</td><td>{ Impo }</td></tr>
                            <tr className="bg-color-gray"><td>Vuelos Facturados</td><td>{ VuelosFacturadosVar }</td></tr>
                        </tbody>
                    </table>
                </div>

                <div 
                    className={`col-md-10 fs-10 table-responsive ${collapsed2 ? '' : 'd-none'}`} 
                    ref={containerRef}
                    style={{ maxHeight: '75vh', overflowY: 'auto' }}
                >
                    <table className="table table-hover" id="main-table">
                        <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 10 }}>
                            <tr>
                                <th className="bg-color-softblue text-white rounded-table-left">#</th>
                                <th className="bg-color-softblue text-white">Folio Fiscal</th>
                                <th className="bg-color-softblue text-white">Concepto</th>
                                <th className="bg-color-softblue text-white">Clave</th>
                                <th className="bg-color-softblue text-white">Año</th>
                                <th className="bg-color-softblue text-white">Semana</th>
                                <th className="bg-color-softblue text-white">Tiempo Demora</th>
                                <th className="bg-color-softblue text-white">Emisor</th>
                                <th className="bg-color-softblue text-white">Origen</th>
                                <th className="bg-color-softblue text-white">Destino</th>
                                <th className="bg-color-blue text-white">Guías</th>
                                <th className="bg-color-blue text-white">Importe MX</th>
                                <th className="bg-color-blue text-white">Kgs Fac</th>
                                <th className="bg-color-blue text-white rounded-table-right">Tarifa</th>
                            </tr>
                        </thead>
                        <tbody id="main-data"></tbody>
                    </table>
                    {loading && <div className="text-center p-3"><b>Cargando...</b></div>}
                </div> 
            </div>
        </div>
    );
}

export default VuelosFacturados;